module.exports = __webpack_public_path__ + "static/media/l_itdot_6.747c7056.png";